export enum Dispositivos {
  Computadoras = 'COMPUTADORAS',
  DispositivosRed = 'DISPOSITIVOS DE RED',
  Impresoras = 'IMPRESORAS',
  Monitores = 'MONITORES',
  Dispositivos = 'DISPOSITIVOS',
  Racks = 'RACKS',
  Telefonos = 'TELEFONOS',
}
